import { definePreset } from '@primevue/themes';
        import Aura from '@primevue/themes/aura';
import './preset.scss';
const Noir = definePreset(Aura, {
    primitive: {},
    semantic: {
    },
    components:{
        multiselect:{
            root:{
                focusBorderColor:"var(--header)",
                sm:{
                    fontSize:"12px"
                }
            }

        },
        inputtext:{
            root:{
                focusBorderColor:"var(--header)"
            }
        },
        select:{
            root:{
                focusBorderColor:"var(--header)"
            }
        },
        checkbox: {
            root: {
                checkedBackground: 'var(--yellow)',
                checkedHoverBackground: 'var(--yellow)',
                checkedBorderColor: 'var(--yellow)',
                checkedHoverBorderColor: 'var(--yellow)',
                checkedFocusBorderColor: 'var(--yellow)',
            },
            // Ensure tick is visible on brand background (invalid --yellow previously left box white + white icon).
            icon: {
                checkedColor: '#ffffff',
                checkedHoverColor: '#ffffff',
            },
        },
        tag:{
            root:{
                fontSize:"0.63rem",
                fontWeight:"600",
                padding: "0.5rem 0.5rem"

            }
        },
        floatlabel: {
            root: {
                focusColor: 'var(--header)',
            },
        },
    }
});
export default Noir;

    
        
        